import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import React, {CSSProperties, useCallback, useEffect, useMemo, useRef, useState} from "react";
import {AgGridReact} from "ag-grid-react"; // Optional Theme applied to the Data Grid
import {ColDef, FirstDataRenderedEvent, GridOptions, GridSizeChangedEvent} from "ag-grid-community";
import {useDispatch} from "react-redux";
import {BaseActionRenderer} from "./cellRenderer/BaseActionRenderer.tsx";
import {StringUtil} from "@/util/StringUtil.ts";
import {useFormik} from "formik";
import {TimeUtil} from "@/util/TimeUtil.ts";
import {ViewActionRenderer} from "./cellRenderer/ViewActionRenderer.tsx";
import {menu} from "@/store/modules/menu.ts";
import {Pagination} from "@/components/pages/Pagination.tsx";


const dateRangeFilter = (filterValue: any, cellValue: string) => {
    if (!filterValue) return true;
    const {dateFrom, dateTo} = filterValue;
    const cellDate = new Date(cellValue);

    if (isNaN(cellDate.getTime())) {
        return false;
    }

    const fromDate = dateFrom ? new Date(dateFrom) : null;
    const toDate = dateTo ? new Date(dateTo) : null;

    return (!fromDate || cellDate >= fromDate) && (!toDate || cellDate <= toDate);
};


export type FieldType = {
    label: string,
    key: string,
    className?: string,
    style?: React.CSSProperties,
    onClick?: (data?: any) => void
    path?: string
    isCurrency?: boolean
    isDate?: boolean
}

export type BaseTableType = {
    title: string,
    component: string,
    fields?: FieldType[],
    items: object[],
    // numberPerPage?: number,
    selectable?: boolean,
    onCellClickAction?: (value: any) => void,
    loading?: boolean,
    refreshPage: () => void
    showToast: boolean
    loader?: boolean
    mainDateColumnFilterKey?: string,
    dateQuery?: boolean
    additionalProps?: boolean
    actions?: {
        view?: boolean
    }
    rowOptions?: { optionName: string, onClick: (data: any) => void; optionStyle?: CSSProperties }[]
}

export default function BaseTable(baseTableType: BaseTableType) {
    const gridRef = useRef<AgGridReact>(null);
    const dispatch = useDispatch();
    // const [pageNo, setPageNo] = useState<number>(0);
    // const [maxPage, setMaxPage] = useState<number>(0);
    // const [pageSize, setPageSize] = useState<number>(10);
    const [loaderState, setLoaderState] = useState<boolean>(baseTableType?.loader || false);
    // const [dataColumnKeysState, setDataColumnKeysState] = useState<{ label: any, value: any }[]>([]);
    const dataColumnKeys: { label: any, value: any }[] = useMemo(() => {
        return [{label: "Select Query Column", value: ""}]
    }, [baseTableType.items])


    // Row Data: The data to be displayed.
    const [rowData, setRowData] = useState<any[]>([]);
    const colDefConfig: ColDef<any>[] = baseTableType?.fields?.map((tableField) => {
        if (TimeUtil.isValidDate(baseTableType && baseTableType?.items && baseTableType?.items[0] ? baseTableType?.items[0][tableField.key] as string : "")) {
            // if (TimeUtil.isValidDate(baseTableType ? baseTableType?.items?.length > 0 ? baseTableType.items[0] ? baseTableType?.items[0][tableField.key] as string : "" : "" : "")) {
            // console.log("dozie", cellDate.getTime())
            // setDataColumnKeys([{label: tableField.label, key: tableField.key}])
            dataColumnKeys.push({label: tableField.label, value: tableField.key})
            // setDataColumnKeys([...dataColumnKeys, {label: tableField.label, key: tableField.key}])
            return {
                field: tableField?.key,
                filter: 'agDateColumnFilter',
                filterParams: {
                    filterFunction: dateRangeFilter,
                    comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
                        const cellDate1 = new Date(cellValue);
                        if (isNaN(cellDate1.getTime())) {
                            return -1;
                        }
                        if (filterLocalDateAtMidnight.getTime() === cellDate1.getTime()) {
                            return 0;
                        }
                        if (cellDate1 < filterLocalDateAtMidnight) {
                            return -1;
                        }
                        if (cellDate1 > filterLocalDateAtMidnight) {
                            return 1;
                        }
                        return 0;
                    },
                    browserDatePicker: true,
                    inRangeInclusive: true,
                    closeOnApply: true,
                    cellStyle: {color: "#000"},
                    buttons: ['apply', 'reset', "cancel"],
                    defaultOption: "inRange",
                    filterOptions: ["inRange"],
                    maxNumConditions: 1
                },
                cellRenderer: BaseActionRenderer,
                cellRendererParams: {
                    onClick: tableField?.onClick,
                    path: tableField?.path,
                    isCurrency: tableField?.isCurrency,
                    // // isDate: tableField?.isDate
                    // isDate: isDate
                },
                headerName: StringUtil.convertToSentenceCase(tableField?.label),
                flex: 1,
                minWidth: 200,
            };
        }

        return {
            field: tableField?.key,
            headerName: StringUtil.convertToSentenceCase(tableField?.label || ""),
            cellRenderer: BaseActionRenderer,
            cellRendererParams: {
                onClick: tableField?.onClick,
                path: tableField?.path,
                isCurrency: tableField?.isCurrency,
            },
            minWidth: 200,
            flex: 1
        }
    })
    const [postPerPage, setPostPerPage] = useState(15)
    const [currPage, setCurrpage] = useState(1)
    const lastPostIndex = currPage * postPerPage
    const firstPostIndex = lastPostIndex - postPerPage


    baseTableType?.actions?.view && colDefConfig.push({
        headerName: "",
        field: "action",
        pinned: "right",
        filter: false,
        minWidth: 50,
        maxWidth: 50,
        cellRenderer: ViewActionRenderer,
        cellRendererParams: {
            title: baseTableType?.title,
            rowOptions: baseTableType?.rowOptions,
            referenceElement: gridRef?.current
        },
        // flex: 0.2
    })

    const openCustomFilter = () => {
        console.log("dozie", formik.values)
        if (formik.values.mainDateField) {
            console.log(formik.values.mainDateField)
            gridRef.current!.api.showColumnFilter(formik.values.mainDateField);
        }
    }

    // const dateFilterSelectOptions = [
    //     {label: "Date Filter", value: ""},
    //     {label: "Today", value: "Today"},
    //     {label: "Last 7 days", value: "Last 7 days"},
    //     {label: "This Month", value: "This Month"},
    //     {label: "Last Month", value: "Last Month"},
    //     {label: "All Time", value: "All Time"},
    //     {label: "Custom", value: "custom"},
    // ]

    const handleOnDateFilterSelect = async (value: string) => {
        let dateFrom = null;
        let dateTo = null;
        const today = new Date();
        const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        // const lastDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        const firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastDayOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);

        switch (value) {
            case 'Today':
                dateFrom = new Date(today.setHours(0, 0, 0, 0));
                dateTo = new Date(today.setHours(23, 59, 59, 999));
                break;
            case 'Last 7 days':
                dateFrom = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
                dateTo = today;
                break;
            case 'This Month':
                dateFrom = new Date(firstDayOfCurrentMonth.setHours(0, 0, 0, 0));
                dateTo = new Date(today.setHours(23, 59, 59, 999));
                break;
            case 'Last Month':
                dateFrom = new Date(firstDayOfLastMonth.setHours(0, 0, 0, 0));
                dateTo = new Date(lastDayOfLastMonth.setHours(23, 59, 59, 999));
                break;
            case 'All Time':
                dateFrom = null;
                dateTo = null;
                break;
            case 'custom':
                openCustomFilter();
                return;
            default:
                break;
        }

        if (gridRef.current) {
            gridRef.current.api.setFilterModel(null);
            const filterModel = gridRef.current.api.getFilterModel() || {};
            if (formik.values.mainDateField) {
                filterModel[formik.values.mainDateField] = {
                    filterType: 'date',
                    type: 'inRange',
                    dateFrom: dateFrom ? dateFrom.toISOString().slice(0, 10) : null,
                    dateTo: dateTo ? dateTo.toISOString().slice(0, 10) : null
                };
                gridRef.current.api.setFilterModel(filterModel);
                gridRef.current.api.onFilterChanged();
            }
        }
    };

    const [colDefs, setColDefs] = useState<ColDef<any>[]>(colDefConfig ? [...colDefConfig] : []);

    const formik = useFormik({
        initialValues: {
            dateFilter: "",
            mainDateField: ""
        },
        onSubmit: handleSubmit
    })

    useEffect(() => {
        setColDefs(colDefConfig ? [...colDefConfig] : [])
        // }, []);
    }, [baseTableType?.fields, baseTableType?.items]);

    const defaultColDef: GridOptions['defaultColDef'] = useMemo(() => {
        return {
            editable: false,
            filter: true,
            cellStyle: {cursor: 'pointer'}
        };
    }, []);

    const paginationPageSizeSelector = useMemo(() => {
        return [10, 20, 50, 100];
    }, []);

    const onGridReady = useCallback((event: GridSizeChangedEvent) => {
        // event.api.resetColumnState();
        // event?.clientWidth > 600 && event.api.sizeColumnsToFit();
        // autoSizeStrategy={{type: "fitCellContents"}}
        event.api.sizeColumnsToFit()
        // event.api.autoSizeAllColumns();
    }, []);

    const onFirstDataRendered = (params: FirstDataRenderedEvent) => {
        params.api.sizeColumnsToFit();
    }


    useEffect(() => {
        dispatch(menu.mutation.setIsBottomMenuOpen(false))
        // setPageNo(1)
        // const x = baseTableType?.items?.length / pageSize
        // setMaxPage(Math.ceil(x))
        setRowData(baseTableType?.items);
    }, [baseTableType?.items]);


    useEffect(() => {
        setLoaderState(baseTableType?.loader || false)
    }, [baseTableType?.loader]);


    async function handleSubmit(values: { dateFilter: string, mainDateField: string }) {
        handleOnDateFilterSelect(values.dateFilter)
    }

    useEffect(() => {
        formik.setFieldValue("mainDateField", baseTableType?.mainDateColumnFilterKey || "")
    }, []);

    useEffect(() => {
        formik.handleSubmit()
    }, [formik.values.dateFilter, formik.values.mainDateField]);

    const onFilterTextBoxChanged = useCallback(() => {
        const searchValue = (document.getElementById("filter-text-box") as HTMLInputElement).value
        gridRef.current!.api.setGridOption(
            "quickFilterText",
            searchValue);
    }, []);

    return (
        <div style={{
            paddingRight: 12,
            // paddingLeft: 12,
            position: "relative",
            width: "100%",
            marginBottom: '20px',
        }}>
            {/*// wrapping container with theme & size*/}
            <div
                className="ag-theme-quartz" // applying the Data Grid theme
                style={{
                    height: "100%",
                    color: "#000",
                    fontSize: ".800rem",
                    fontWeight: "400",
                    gap: 5,
                    display: "flex",
                    flexDirection: "column",
                    // border: "10px solid gray",
                }} // the Data Grid will fill the size of the parent container
            >
                <div className="allapps-body all-users-body">
                    <div className="margin-top">
                        <div className="search-pagination-wrapper" style={{marginBottom: "2rem"}}>
                            <div className="icn">
                                <i className="bx bx-search"></i>
                            </div>
                            <input
                                className="search-input2 bg-white"
                                maxLength={256}
                                id={'filter-text-box'}
                                onInput={onFilterTextBoxChanged}
                                name="field-3"
                                data-name="Field 3"
                                placeholder="Filter by any column name or search by keyword"
                                type="text"
                                // id="field-3"
                                required
                            />
                        </div>
                    </div>
                    <AgGridReact
                        containerStyle={{
                            width: '100%',
                            overflowX: 'auto',
                            // maxHeight: '100%',
                            overflow: 'auto',
                            border: '1px solid var(--border--normal)',
                            borderRadius: '5px',
                            fontSize: '12px'
                        }}
                        ref={gridRef}
                        rowData={rowData.slice(firstPostIndex, lastPostIndex)}
                        columnDefs={colDefs}
                        defaultColDef={defaultColDef}
                        onCellClicked={(event) => {
                            if (event.colDef.field?.toLowerCase() == 'action') {
                                event.event?.stopPropagation();
                            } else {
                                baseTableType?.onCellClickAction && baseTableType.onCellClickAction(event.data)
                            }
                        }}
                        pagination={true}
                        // paginationPageSize={pageSize}
                        paginateChildRows={true}
                        paginationPageSizeSelector={paginationPageSizeSelector}
                        rowHeight={30}
                        headerHeight={40}
                        onGridSizeChanged={onGridReady}
                        onFirstDataRendered={onFirstDataRendered}
                        suppressPaginationPanel={true}
                        rowSelection={'multiple'}
                        rowGroupPanelShow={'always'}
                        serverSideInitialRowCount={10}
                        loading={loaderState}
                        domLayout={"autoHeight"}
                    />
                    <Pagination increasePage={() => setCurrpage(n => n + 1)}
                                decreasePage={() => setCurrpage(n => n - 1)}
                                setPage={() => setCurrpage(1)}
                                postPerPage={15}
                                totalPosts={rowData.length}
                                page={currPage}
                    />
                </div>
            </div>

        </div>
    )
}